export const navLinks = [
  { name: 'Header.main', path: '' },
  { name: 'Header.about', path: '/about' },
  { name: 'Header.services', path: '/services' },
  { name: 'Header.contacts', path: '/contacts' },
];
